export default class CreateOpportunityRequest {
    name = '';
    description = '';
    workTypes: string[] = [];
    ownerId: string | null = null;
    branchId: string | null = null;
    deskId: string | null = null;
    sourceId: string | null = null;
    campaignId: string | null = null;
    value = 0;
    valueType = 1;
    expectedCloseDate: string | null = null;

    companyId: string | null = null;
    locationId: string | null = null;
    contactId: string | null = null;

    prospectCompanyName = '';
    prospectCompanyEmail = '';
    prospectCompanyPhone = '';
    prospectCompanyWebsite = '';
    prospectCompanyTaxNumber = '';
    prospectCompanyRegistrationNumber = '';

    prospectCompanyAddressType = '';
    prospectCompanyAddressBuilding = '';
    prospectCompanyAddressStreet = '';
    prospectCompanyAddressLocality = '';
    prospectCompanyAddressCity = '';
    prospectCompanyAddressRegion = '';
    prospectCompanyAddressPostcode = '';
    prospectCompanyAddressCountry = '';
    prospectCompanyAddressLatitude: number | null = null;
    prospectCompanyAddressLongitude: number | null = null;

    prospectLocationName = '';
    prospectLocationEmail = '';
    prospectLocationPhone = '';
    prospectLocationAddress1 = '';
    prospectLocationAddress2 = '';
    prospectLocationLocality = '';
    prospectLocationCity = '';
    prospectLocationRegion = '';
    prospectLocationPostcode = '';
    prospectLocationCountry = '';

    prospectLocationTypeId: string | null = null;
    prospectLocationLatitude: number | null = null;
    prospectLocationLongitude: number | null = null;

    prospectContactFirstName = '';
    prospectContactLastName = '';
    prospectContactEmail = '';
    prospectContactMobilePhoneNumber = '';
    prospectContactOtherPhoneNumber = '';
    prospectContactJobTitle = '';
    prospectContactPositionId: string | null = null;
    prospectContactIsAgreedToMarketing = true;
}
